import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'td-wb-page-header-title',
  template: '<ng-content></ng-content>',
  styleUrls: ['page-header-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderTitleComponent {
}
